import axios from "axios";
import { API_HOST } from "../constants";

let headers = {};
const getAuth = () => {
  const authData = localStorage.getItem("Authorization");
  if (authData) {
    headers = { Authorization: authData };
  }
};

export const getESUBs = async (query) => {
  getAuth();
  return await axios
    .get(`${API_HOST}/esub/ESUBs?filter=${query}`, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

export const searchEsubProject = async (
  title,
  number,
  location,
  onSuccess,
  onFailure
) => {
  getAuth();
  return await axios
    .get(
      `${API_HOST}/esub/search?title=${title}&number=${number}&location=${location}`,
      { headers }
    )
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const filterEsubProjects = async (query, data) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/projects?filter=${query}`, data, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};


export const getEsubPersonnels = async (query, data) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/personnel`, data, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};



export const filterEsubBank = async (query, data) => {
  getAuth();
  headers["Content-Type"] = "application/json";
  return await axios
    .post(`${API_HOST}/esub/bank?filter=${query}`, data, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

export const filterEsubBonding = async (query, data) => {
  getAuth();
  headers["Content-Type"] = "application/json";
  return await axios
    .post(`${API_HOST}/esub/bonding?filter=${query}`, data, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

export const filterEsubInsuranceGi = async (query, data) => {
  getAuth();
  headers["Content-Type"] = "application/json";
  return await axios
    .post(`${API_HOST}/esub/insurance/gi?filter=${query}`, data, {
      headers,
    })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

export const filterEsubInsuranceAi = async (query) => {
  getAuth();
  headers["Content-Type"] = "application/json";
  return await axios
    .get(`${API_HOST}/esub/insurance/ai?filter=${query}`, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

export const filterEsubInsuranceCi = async (query) => {
  getAuth();
  headers["Content-Type"] = "application/json";
  return await axios
    .get(`${API_HOST}/esub/insurance/ci?filter=${query}`, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

export const openEsubProjects = async (query) => {
  getAuth();
  headers["Content-Type"] = "application/json";
  return await axios
    .get(`${API_HOST}/esub/openprojects?filter=${query}`, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};


export const getSingleEsubProject = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .get(`${API_HOST}/esub/singleproject/edit/${id}`, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      } else {
        console.error("API Error:", err); // Logs the full error for debugging
        if (onFailure) onFailure(err);
      }
    });    
};

export const deleteSingleEsubProject = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/singleproject/delete/${id}`, {}, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const getSingleEsubPersonnel = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .get(`${API_HOST}/esub/singlepersonnel/edit/${id}`, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const deleteSingleEsubPersonnel = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .post(
      `${API_HOST}/esub/singlepersonnel/delete/${id}`,
      {},
      { headers }
    )
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const deleteSingleEsub = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/singleesub/delete/${id}`, {}, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const reviewSingleEsub = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/singleesub/review/${id}`, {}, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const downloadSingleEsub = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/singleesub/download/${id}`, {}, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      // onFailure(err.response)
    });
};

export const tamplateSingleEsub = async (id, onSuccess, onFailure) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/singleesub/template/${id}`, {}, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const esubFormatRemaining = async (
  id,
  data = {},
  onSuccess,
  onFailure
) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/esubformatremaining/${id}`, data, { headers })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};

export const pledgxEsubFormatRemaining = async (
  id,
  data = {},
  onSuccess,
  onFailure
) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/pledgxformatremaining/${id}`, data, {
      headers,
    })
    .then((res) => onSuccess(res.data))
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
      onFailure(err.response);
    });
};


export const checkUnderwriterUserAvailable = async (data) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/check_underwriter_user_available`, data, { headers })
    .then((res) => res.data)
    .catch(
      (err) => err.response.data
    );
};


export const getESUBsForSingleAccount = async (data) => {
  getAuth();
  return await axios
    .post(`${API_HOST}/esub/all/esubs/for/single/account`, data, { headers })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        localStorage.removeItem("Authorization");
        dispatchEvent(new Event("storage"));
      }
    });
};

